import { useState } from "react";
import { Loader2 } from "lucide-react";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogCancel,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";

// Confirmation for sensitive account actions; optional reason, optional typed confirmation.
export function ConfirmAction({ open, title, body, confirmLabel, danger, typeToConfirm, caseSensitive, noReason, children, onConfirm, onClose, testId }) {
  const [reason, setReason] = useState("");
  const [typed, setTyped] = useState("");
  const [busy, setBusy] = useState(false);
  const blocked = typeToConfirm && (caseSensitive ? typed.trim() !== typeToConfirm : typed.trim().toLowerCase() !== typeToConfirm.toLowerCase());
  const go = async () => {
    setBusy(true);
    try { await onConfirm({ reason, typed }); onClose(); setReason(""); setTyped(""); } finally { setBusy(false); }
  };
  return (
    <AlertDialog open={open} onOpenChange={(o) => !o && !busy && onClose()}>
      <AlertDialogContent data-testid={testId} className="max-h-[90vh] overflow-y-auto">
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription asChild><div className="text-sm text-stone-600 space-y-2">{body}</div></AlertDialogDescription>
        </AlertDialogHeader>
        {children}
        {typeToConfirm ? (
          <div>
            <label className="text-xs text-stone-600">Type <strong className="break-all">{typeToConfirm}</strong> to confirm</label>
            <Input data-testid="confirm-type-input" value={typed} onChange={(e) => setTyped(e.target.value)} className="mt-1" />
          </div>
        ) : !noReason && (
          <Textarea data-testid="confirm-reason-input" value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Reason (optional, saved in the audit history)" className="min-h-[70px]" />
        )}
        <AlertDialogFooter>
          {!noReason && <AlertDialogCancel data-testid="confirm-cancel" disabled={busy}>Cancel</AlertDialogCancel>}
          <Button data-testid="confirm-ok" onClick={go} disabled={busy || blocked}
            className={danger ? "bg-red-700 hover:bg-red-800 text-white" : "bg-stone-900 hover:bg-stone-800 text-white"}>
            {busy && <Loader2 className="h-4 w-4 mr-1.5 animate-spin" />}{confirmLabel}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
